
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientRequest,
  CountryResource,
  InvitedClientResource,
  KnownClientResource,
  OpportunitiesResource,
  ProposalsWithClientResource,
} from '../models';
import {
    ClientRequestFromJSON,
    ClientRequestToJSON,
    CountryResourceFromJSON,
    CountryResourceToJSON,
    InvitedClientResourceFromJSON,
    InvitedClientResourceToJSON,
    KnownClientResourceFromJSON,
    KnownClientResourceToJSON,
    OpportunitiesResourceFromJSON,
    OpportunitiesResourceToJSON,
    ProposalsWithClientResourceFromJSON,
    ProposalsWithClientResourceToJSON,
} from '../models';

export interface GetRelationOpportunitiesRequest {
    clientIdentityId: string;
}

export interface InviteClientRequest {
    clientRequest: ClientRequest;
}

/**
 * 
 */
export class FreelancerClientApi extends runtime.BaseAPI {

    /**
          */
    async getClientAvailableCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResource>>({
            path: `/project-freelancer/api/client/country`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResourceFromJSON);
        return response;
    }

    /**
          */
    async getClientAvailableCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResource>> {
        const response = await this.getClientAvailableCountriesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerClientsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<KnownClientResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<KnownClientResource>>({
            path: `/project-freelancer/api/client`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(KnownClientResourceFromJSON);
        return response;
    }

    /**
          */
    async getFreelancerClients(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<KnownClientResource>> {
        const response = await this.getFreelancerClientsRaw(initOverrides);
        return response._data;
    }

    /**
     * Return the list of proposals waiting for a quote and their associated client
          */
    async getProposalsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProposalsWithClientResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProposalsWithClientResource>({
            path: `/project-freelancer/api/client/proposal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProposalsWithClientResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Return the list of proposals waiting for a quote and their associated client
          */
    async getProposals(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProposalsWithClientResource> {
        const response = await this.getProposalsRaw(initOverrides);
        return response._data;
    }

    /**
     * Return the list of proposals waiting for a quote or projects to renew
          */
    async getRelationOpportunitiesRaw(requestParameters: GetRelationOpportunitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OpportunitiesResource>> {
        if (requestParameters['clientIdentityId'] == null) {
            throw new runtime.RequiredError(
                'clientIdentityId',
                'Required parameter "clientIdentityId" was null or undefined when calling getRelationOpportunities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OpportunitiesResource>({
            path: `/project-freelancer/api/client/{clientIdentityId}/opportunity`.replace(`{${"clientIdentityId"}}`, encodeURIComponent(String(requestParameters['clientIdentityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OpportunitiesResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Return the list of proposals waiting for a quote or projects to renew
          */
    async getRelationOpportunities(requestParameters: GetRelationOpportunitiesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OpportunitiesResource> {
        const response = await this.getRelationOpportunitiesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async inviteClientRaw(requestParameters: InviteClientRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<InvitedClientResource>> {
        if (requestParameters['clientRequest'] == null) {
            throw new runtime.RequiredError(
                'clientRequest',
                'Required parameter "clientRequest" was null or undefined when calling inviteClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<InvitedClientResource>({
            path: `/project-freelancer/api/client`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientRequestToJSON(requestParameters['clientRequest']),
        }, initOverrides);

        if (response._data) { response._data=InvitedClientResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async inviteClient(requestParameters: InviteClientRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<InvitedClientResource> {
        const response = await this.inviteClientRaw(requestParameters, initOverrides);
        return response._data;
    }

}
